import { ReactElement, Suspense, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { useHttpLoading } from 'shell/hooks/use-http-loading';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';
import OverlaySpinner from '../../components/shared/overlay-spinner';
import classNames from 'classnames';
import { Outlet } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import { useNavbarHeight } from 'shell/hooks/use-navbar-height';
import { useListener } from 'shell/hooks/use-bus';
import { SIDEBAR_OPEN_EVENT } from 'shell/constants/events';

const useStyles = makeStyles(() => ({
  layoutMain: {
    flexGrow: 1,
    backgroundColor: '#f0f0f0',
  },
}));

const Layout = (): ReactElement => {
  const classes = useStyles();
  const { isLoading } = useHttpLoading();

  const [hasPadding, setHasPadding] = useState(true);

  const height = useNavbarHeight();

  useListener<boolean>(SIDEBAR_OPEN_EVENT, (open) => {
    setHasPadding(!open);
  });

  return (
    <div className="pmi-d-flex pmi-flex-column pmi-h-100">
      <OverlaySpinner visible={isLoading} />
      <Navbar>
        <>
          <div
            className={classNames(
              'pmi-p-3 pmi-px-sm-5 pmi-py-sm-4 pmi-pb-md-5',
              classes.layoutMain
            )}
          >
            <Suspense fallback={<LinearProgress />}>
              <div style={{ paddingTop: hasPadding ? `${height}px` : undefined }}></div>
              <Outlet />
            </Suspense>
          </div>
          <Footer />
        </>
      </Navbar>
    </div>
  );
};

Layout.displayName = 'Layout';

export default Layout;
